interface FilterLabelProps {
    label: string;
    onRemove: () => void;
}

const FilterLabel = ({ label, onRemove }: FilterLabelProps) => {
    return (
        <div className="max-w-[275px] h-[24px] bg-secondary-50 text-blue-500 rounded-[4px] px-[10px] py-[2px] font-semibold x-small flex items-center gap-[8px]">
            <span className="font-poppins font-semibold text-[12px] leading-[20px] tracking-[1px] uppercase truncate">{label}</span>
            <svg
                onClick={onRemove}
                className="cursor-pointer flex-shrink-0"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4 12L12 4M4 4L12 12"
                    stroke="#3460DC"
                    strokeWidth="1.13"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export default FilterLabel;
